import React, { createContext, useMemo, useContext, useEffect, useState } from "react";
import socketIOClient from "socket.io-client";
import { CHAT_SOCKET_URL } from "../config";
import { userDetailsSelector, userTokenSelector } from "../rdxsga/redux/slices/userSlice";
import { useSelector } from "react-redux";
import { useUserAction } from "../rdxsga/hooks/actions/users/useUserActionHook";
import { toast } from "react-toastify";

const SocketContext = createContext(null);

export const useChatSocket = () => {
    const { socket } = useContext(SocketContext);
    return socket;
};

export const useOnlineUsersSocket = () => {
    const { onlineUsers } = useContext(SocketContext);

    return onlineUsers;
}


export const useMessageNotification = () => {
    const { unseenMessages } = useContext(SocketContext);
    return unseenMessages
}


export const ChatSocketProvider = (props) => {
    const userAction = useUserAction();

    const token = useSelector(userTokenSelector);
    const userDetails = useSelector(userDetailsSelector)


    const [socket, setSocket] = useState(null);
    const [onlineUsers, setOnlineUsers] = useState([])
    const [unseenMessages, setUnseenMessages] = useState({})


    const newUnseenMessages = useMemo(() => {
        // Compute the new unseenMessages here
        const messages = unseenMessages;

        // Compare with the current unseenMessages
        if (JSON.stringify(messages) === JSON.stringify(unseenMessages)) {
            return unseenMessages;
        }

        return messages;
    }, [unseenMessages]);



    const handleOnlineUsers = (res) => {
        setOnlineUsers(res)
    };


    const onReceivedUnseenMessages = (res) => {
        if (res?.success && res?.statusCode >= 200 && res?.statusCode <= 300) {
            const data = res.data;
            setUnseenMessages(data);
        } else if (res.statusCode === 401) {
            userAction.logoutUser();
        } else {
            toast.error(res.message ?? "Something Wrong !");
        }
    };


    const onErrorOccurred = (res) => {
        //console.log({ res });
        if (res?.success && res?.statusCode >= 200 && res?.statusCode <= 300) {
            const data = res.data;
        } else if (res.statusCode === 401) {
            toast.error(res?.message ?? "Something Wrong !");
            userAction.logoutUser();
        } else {
            toast.error(res.message ?? "Something Wrong !");
        }
    };


    useEffect(() => {
        let newSocket = null;
        let unseenFetcher = null;
        //console.log("userDetails", userDetails)
        if (userDetails?.isAuthenticated) {
            newSocket = socketIOClient(CHAT_SOCKET_URL, {
                reconnection: true,
                withCredentials: true,
                transports: ["polling", "websocket"],
                query: { userId: userDetails?.user?._id },
                extraHeaders: {
                    Authorization: `Bearer ${token}`,
                },
            });
            console.log({ newSocket })
            setSocket(newSocket);

        }


        if (newSocket) {
            // newSocket.on("unseenMessages", onReceivedUnseenMessages);
            newSocket.on('onlineUsers', handleOnlineUsers)
            newSocket.on("error", onErrorOccurred)

            // unseenFetcher = setInterval(() => {
            //     newSocket && newSocket.emit("getUnseen", {});
            // }, 5000);

        }


        return () => {
            if (newSocket) {
                newSocket.close();
                newSocket.off('onlineUsers', handleOnlineUsers)
                // newSocket.off("unseenMessages", onReceivedUnseenMessages);
                newSocket.off("error", onErrorOccurred);
            }
            // clearInterval(unseenFetcher)
        };
    }, [userDetails]);

    return (
        <SocketContext.Provider value={{
            socket,
            onlineUsers,
            unseenMessages: newUnseenMessages
        }}>
            {props.children}
        </SocketContext.Provider>
    );
};